module.exports = __webpack_public_path__ + "static/headerlogo-5d0e833bff997d5303d201b1eae96536.png";